import React from "react";

import { cva, VariantProps } from "class-variance-authority";

import * as theme from "./Cell.css";

const cellVariants = cva(theme.cell, {
    variants: {
        backgroundVariant: {
            default: "",
        },
        sorted: {
            true: theme.cellSorted,
        },
        pinned: {
            true: theme.cellPinned,
        },
    },
});

export type CellWidth = number | `${number}%`;

export interface CellProps {
    children: React.ReactNode;
    sorted?: boolean;
    width?: CellWidth;
    left?: number;
    pinned?: boolean;
    backgroundVariant?: VariantProps<typeof cellVariants>["backgroundVariant"];
}
export function Cell({
    children,
    sorted,
    width,
    left,
    pinned,
    backgroundVariant = "default",
}: CellProps) {
    return (
        <td
            className={cellVariants({
                backgroundVariant,
                sorted,
                pinned,
            })}
            style={{
                width: width ?? "auto",
                left: left ?? 0,
            }}
        >
            {children}
        </td>
    );
}
